import { Avatar, AvatarPair, Label } from "@primer/components";
import React from "react";
import { useGetAllContributors } from "../../queries/useGetContributors";
import Loader from "../../assets/loader.gif";
import "../../scss/_table.scss";

function Table() {
  const {
    data: contributorsAllList,
    isSuccess,
    isLoading,
    isError,
  } = useGetAllContributors();

  return (
    <>
      <section className="fdb-block bg-peach-light bg-img">
        <div className="bg-img-2">
          <div className="container">
            <div className="container table-responsive py-10">
              {/*TODO: Need to Impl*/}
              {/*<Box mt={2} mb={4}>*/}
              {/*  <ButtonOutline m={2}>This Month</ButtonOutline>*/}
              {/*  <ButtonDanger m={2}>Last Month</ButtonDanger>*/}
              {/*  <ButtonOutline m={2}>All</ButtonOutline>*/}
              {/*  <ButtonPrimary m={2}>Board Members</ButtonPrimary>*/}
              {/*</Box>*/}

              <table className="table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Rank</th>
                    <th scope="col">Contributor</th>
                    <th scope="col">Points</th>
                  </tr>
                </thead>
                {isLoading && (
                  <>
                    <span className={"anim-pulse"}>
                      <img src={Loader} width="20px" alt="" />
                    </span>
                    <span className="AnimatedEllipsis" />
                  </>
                )}
                {isError && (
                  <div className="flash mt-3 flash-error">
                    Failed to get contributors
                  </div>
                )}
                {isSuccess && (
                  <tbody>
                    {contributorsAllList?.map((r, i) => (
                      <tr key={r.login}>
                        <th scope="row">{i + 1}</th>
                        <td className="d-flex justify-content-start">
                          <AvatarPair
                            className={
                              r?.login === "dependabot" ? "anim-pulse" : ""
                            }
                          >
                            <Avatar src={r?.url} size={40} />
                            <Avatar src="https://avatars.githubusercontent.com/github" />
                          </AvatarPair>{" "}
                          <a
                            className="px-2 "
                            href={`https://github.com/${r?.login}`}
                            target={"_blank"}
                            rel="noreferrer"
                          >
                            {r?.login}
                          </a>
                          {r?.login === "dependabot" && (
                            <p className="text-left text-italic">
                              : At least make contributions than I do!
                            </p>
                          )}
                        </td>
                        <td>
                          <Label variant="medium" bg="#B53A25" m={1}>
                            {r?.points}
                          </Label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Table;
